import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { ContractService } from 'src/app/services/contract.service';
import { ContractData } from 'src/app/intefaces/contract-data.interface';

@Component({
  selector: 'contract-data',
  templateUrl: './contract-data.component.html',
  styleUrls: ['./contract-data.component.scss']
})
export class ContractDataComponent implements OnInit {

  isDataReady = false;
  contractDetailsForm: FormGroup;
  contractDetailsFormPreviousValues: any;
  isEditing = false;
  showLoader = false
  testEmailAddress: string;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: HttpAlertService,
    private translate: TranslateService,
    private router: Router,
    private contractService: ContractService
  ) {

    this.contractDetailsForm = this.formBuilder.group({
      company_name: ['', Validators.required],
      company_street: ['', Validators.required],
      company_house_no: ['', Validators.required],
      company_postal_code: ['', Validators.required],
      company_city: ['', Validators.required],
      company_nip: ['', Validators.required],
    });

  }

  ngOnInit(): void {
    this.isDataReady = true;
    this.contractService.getContractData().subscribe((response: any) => {
      this.populateForm(response.data.contract_data);
    });
  }

  private populateForm(contractData: ContractData): void {
    this.contractDetailsForm.patchValue(contractData);
    setTimeout(() => {
      this.disabledForm();
    }, 100);
    this.isDataReady = true;
  }

  private disabledForm(): void {
    this.contractDetailsForm.disable();
    this.isEditing = false;
  }

  private enableForm(): void {
    this.contractDetailsForm.enable();
    this.isEditing = true;
  }

  public startEditing(): void {
    this.contractDetailsFormPreviousValues = this.contractDetailsForm.value;
    this.enableForm();
  }

  public cancelEditing(): void {
    this.contractDetailsForm.setValue(this.contractDetailsFormPreviousValues);
    this.disabledForm();
  }

  public onSubmit(): void {
    this.disabledForm();
    this.translate.get(['data_updated_success', 'data_updated_error']).subscribe(t => {
      this.contractService.updateContractData(this.contractDetailsForm.value).subscribe(
        result => { this.alertService.success(t.data_updated_success); },
        error => { this.alertService.error(t.data_updated_error); }
      );
    });
  }

  public downloadExampleContract(): void {
    this.showLoader = true;
    this.contractService.downloadTestContract().subscribe(
      blob => {
        this.showLoader = false;
        saveAs(blob, 'test_contract.pdf');
      },
      error => {
        console.error(error);
      }
    );
  }

  public onEditContractEmail(): void {
    this.router.navigate(['/administrator-panel/information-page-editor', 0, 'pl', 'contract_email']);
  }

  public onSendTestEmail(): void {

  }

}

